module.exports = __webpack_public_path__ + "img/wasp_game.01d29753.png";